import { PropsWithChildren } from 'react';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { newTheme } from '@siloreal:app:config/init/mui-config';

export function MuiProvider({ children }: PropsWithChildren) {
  return (
    <ThemeProvider theme={newTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
